import { IReportDefinition } from '@common/interfaces/report'
import Base from './base'

export default class Reports extends Base {
  list() {
    return this.apiClient.get('/reports')
  }

  show(id: string) {
    return this.apiClient.get(`/reports/${id}`)
  }

  create(data: object) {
    return this.apiClient.post('/reports', data)
  }

  update(id: string, data: object) {
    return this.apiClient.put(`/reports/${id}`, data)
  }

  share(id: string, data: { userIds: string[]; teamIds: string[] }) {
    return this.apiClient.put(`/reports/${id}/shares`, data)
  }

  delete(id: string) {
    return this.apiClient.delete(`/reports/${id}`)
  }

  run(data: IReportDefinition & { page: number; perPage: number }) {
    return this.apiClient.post('/reports/run', data)
  }

  openConversation(data: { reportId?: string }) {
    return this.apiClient.post('/reports/conversation', data)
  }

  export(data: IReportDefinition & { name?: string }) {
    return this.apiClient.post('/reports/export', data, { isFile: true })
  }
}
